import ChargebeeAddon from 'modules/upsell/lib/selfUpsell/calculator/ChargebeeAddon'
import getF25PlanPricing from 'modules/upsell/lib/selfUpsell/calculator/getF25Pricing'
import Feature from 'modules/upsell/lib/selfUpsell/plans/Feature'
import PlanVariant from 'modules/upsell/lib/selfUpsell/plans/PlanVariant'
import {
  DATO_PLAN_DESCRIPTION_FIELD,
  DATO_PLAN_ICON_FIELD,
  DATO_PLAN_ID_FIELD,
  DATO_PLAN_SEG_OPTION_FIELD,
  DATO_PLAN_TITLE_FIELD,
  DEFAULT_ICON,
  PRO_PLAN_TYPE,
  STARTER_PLAN_TYPE,
  getVariantFromID,
} from 'modules/upsell/lib/selfUpsell/plans/utils'
import { PlanTypeEnum, SelfUpsell } from 'modules/upsell/lib/selfUpsell/types'

export function initF25AddonVariants(rawBundles: SelfUpsell, country: string) {
  const f25AddonVariants: PlanVariant[] = []

  rawBundles.allF25Addons.forEach((f25Addon) => {
    if (!f25Addon.regions[0]) return

    const features = f25Addon.regions[0].features.map(
      (feature) => new Feature(feature.title, feature.tooltip)
    )
    const chargebeeAddons = f25Addon.regions[0].chargebeeAddons.map((addon) => {
      return new ChargebeeAddon(
        addon.addonId,
        addon.currencyCode,
        addon.period,
        addon.periodUnit,
        addon.pricingModel,
        addon.chargeType,
        addon.selectedCountries,
        addon.price,
        addon.tiers,
        addon.originalPrice ?? null
      )
    })

    const pricing = getF25PlanPricing(chargebeeAddons, country)

    if (!pricing) return

    const planType: PlanTypeEnum = f25Addon[DATO_PLAN_ID_FIELD]
      .toLowerCase()
      .includes(PRO_PLAN_TYPE)
      ? PRO_PLAN_TYPE
      : STARTER_PLAN_TYPE

    const variantOptions = {
      id: f25Addon[DATO_PLAN_ID_FIELD],
      title: f25Addon[DATO_PLAN_TITLE_FIELD],
      type: getVariantFromID(f25Addon[DATO_PLAN_ID_FIELD]),
      description: f25Addon[DATO_PLAN_DESCRIPTION_FIELD],
      segmentationOption: f25Addon[DATO_PLAN_SEG_OPTION_FIELD],
      icon: f25Addon[DATO_PLAN_ICON_FIELD] || DEFAULT_ICON,
      features,
      pricing,
      planType,
    }

    f25AddonVariants.push(new PlanVariant(variantOptions))
  })

  return f25AddonVariants
}
